import { MenuItemOptions } from "@finanedi.es/storybook"
import { faDownload } from "@fortawesome/pro-light-svg-icons"
import { TFunction } from "i18next"

export const getOptions = (
  exportToExcel: () => void,
  t: TFunction
): MenuItemOptions[] => [
  {
    title: `${t("bancos.idView.labelDownload")}`,
    hasRedirect: false,
    icon: faDownload,
    className: "tw-text-text-50",
    action: exportToExcel,
  },
]

export const TABS_COMP = {
  FIRST_TAB: 0,
  SECOND_TAB: 1,
} as const

export type TipoPrestamoType = (typeof TABS_COMP)[keyof typeof TABS_COMP]
